import { createForm } from "@jsr/tarcltd__form";
import { computed, reactive } from "vue";
export { deep as useDeep, reForm as useReForm, nameReForm as useNameReForm, groupReForm as useGroupReForm } from "@jsr/tarcltd__form";
/**
 * Generate a form object with Zod validation from a schema definition.
 *
 * @param schema - A schema definition.
 * @param state - The form state.
 * @param options - Options for the form.
 *   - `defaults`: The default values for the form.
 *   - `impl`: The implementation object for the form.
 * @returns An object with the following properties:
 * - `input`: The form schema definition.
 * - `state`: The form state.
 * - `schema`: The parsed `ZodObject` schema.
 * - `reset`: Reset the form to its default values.
 * - `isValid`: A computed property that returns whether the form is valid.
 */ /* biome-ignore lint/suspicious/noExplicitAny: */ export function useForm(schema, options = {
  defaults: {},
  impl: {}
}) {
  const state = reactive({});
  const ret = createForm(schema, state, options);
  return {
    ...ret,
    isValid: computed(()=>ret.schema.safeParse(ret.state).success)
  };
}
export default useForm;
//# sourceMappingURL=index.js.map